export enum DateFormatter {
  DATE_TIME = "dd.MM.yy',' HH:mm",
  TIME = 'HH:mm',
  DATE_FULL_YEAR = 'dd.MM.yyyy',
  DATE_SHORT_YEAR = 'dd.MM.yy',
  DATE_OF_MONTH_TIME_FORMAT = 'do MMMM yyyy, HH:mm a'
}
